import { render, staticRenderFns } from "./FormDevice.vue?vue&type=template&id=48e2c9b4&"
import script from "./FormDevice.vue?vue&type=script&lang=js&"
export * from "./FormDevice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports